import styled from 'styled-components';

import { VerticalCenterBlock, VerticalHorizontalCenterBlock } from '../../../../styled';

export const Wrapper = styled(VerticalCenterBlock)`
  gap: 20px;
  margin-top: 32px;
`;

export const StepWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FetchingWrapper = styled(VerticalHorizontalCenterBlock)`
  width: 100%;
  height: 44px;
`;

export const Title = styled.div`
  ${(p) => p.theme.typography.notification};
  color: ${(p) => p.theme.colors.muted};
`;

export const Description = styled.div`
  ${(p) => p.theme.typography.notification};
`;
